var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_cof.js